import type { ReactNode } from "react";
import { VaultRequirementIdContext } from "./VaultRequirementScopeContext";

interface VaultRequirementScopeProps {
  readonly children: ReactNode;
  readonly requirementId: string;
}

export function VaultRequirementScope({
  children,
  requirementId,
}: VaultRequirementScopeProps) {
  return (
    <VaultRequirementIdContext.Provider value={requirementId}>
      {children}
    </VaultRequirementIdContext.Provider>
  );
}
